import { render } from "./PodcastsComponent.vue?vue&type=template&id=66a38164&ts=true"
import script from "./PodcastsComponent.vue?vue&type=script&lang=ts"
export * from "./PodcastsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__